<div class="finish flex flex-col gap-4">
  <div class="header text-center">
    <h2>Recovery result</h2>
    <p>Your subscriptions have been processed, which status are shown in the table below.</p>
  </div>
  <table mat-table [dataSource]="subscriptionsSelected" class="mat-elevation-z8">
    <ng-container matColumnDef="subscriptions">
      <th mat-header-cell *matHeaderCellDef rowspan="1">Available credits</th>
      <td mat-cell *matCellDef="let subscription">
        {{ subscription.primaryProductName }} - {{ subscription.primarySkuName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="total-amount" rowspan="1">Status</th>
      <td mat-cell *matCellDef="let subscription">
        <div class="flex items-center gap-2">
          <mat-icon class="icon-check-circle">check_circle</mat-icon>
          <span>COMPLETED</span>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <p class="text-center">
    To make sure there is no disruption with your service, please click on the
    <a class="recover-link" href="{{ getRecoveryLink() }}">recovery link</a> to renew your remain failed subscriptions.
    You can also do this later by revisiting the recovery email.
  </p>
</div>
